export { BatchSendStatus, BatchStoreStatus, StorageType } from "./Interfaces/IOfflineBatch";
export { StorageProviders } from "./Interfaces/IOfflineProvider";
export { WebStorageProvider } from "./Providers/WebStorageProvider";
export { IndexedDbProvider } from "./Providers/IndexDbProvider";
export { OfflineBatchHandler } from "./OfflineBatchHandler";
export { InMemoryBatch } from "./InMemoryBatch";
export { Sender } from "./Sender";
export { OfflineChannel } from "./OfflineChannel";
//# sourceMappingURL=applicationinsights-offlinechannel-js.js.map